import { render, staticRenderFns } from "./left1.vue?vue&type=template&id=2e94cd4a&scoped=true&"
import script from "./left1.vue?vue&type=script&lang=js&"
export * from "./left1.vue?vue&type=script&lang=js&"
import style0 from "./left1.vue?vue&type=style&index=0&id=2e94cd4a&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e94cd4a",
  null
  
)

export default component.exports